import axios from "../../axiosInstance"

const postPosition = async (id, data) =>
  await axios.post(`career-page/avalith/jobs/${id}/apply/`, data)

const getPositionDetails = async (id) =>
  await axios.get(`career-page/avalith/jobs/${id}`)

export { postPosition, getPositionDetails }
